import { gql } from "@apollo/client";

const IMPACTED_ASSETS_CREDENTIAL_QUERY = gql`
  query impactedAssetsCredential($credentialName: String!) {
    impactedDownloads(credentialName: $credentialName) {
      edges {
        node {
          id
          name
        }
      }
    }

    impactedUploads(credentialName: $credentialName) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export { IMPACTED_ASSETS_CREDENTIAL_QUERY };
